import { NgModule, Component, Input, ChangeDetectionStrategy, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import {APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: 'video-embed-share',
    templateUrl: 'video-embed-share.template.html',
    styleUrls: ['video-embed-share.style.scss']
})
export class VideoEmbedShare {
    @Input() item: any;
    @Input() media: any;
    isCopied1: boolean = false;
    isCopied2: boolean = false;

    public active: boolean = false;
    private subscriptions: any[] = [];
    private shown: Observable<boolean>;
    private time: any;
    private duration:any;
    private includeTime: boolean;
    private selectedSize: any;
    private videoSizes;// = AppSettings.VIDEO_EMBED_SIZE_OPTIONS;

    private get embedCode() {
        let mark = this.includeTime && this.timeToDecimal(this.time),
            path = this.location.path().replace("/embed/", "/").concat(mark ? `?t=${mark}` : '').toLowerCase(),
            width = this.selectedSize.width, height = this.selectedSize.height;
        return `${this.settings['VIDEO_EMBED_CODE'].replace('{path}', path).replace('{width}', width).replace('{height}', height)}`;
    }

    private get shareLink() {
        let loc = document.location,
            mark = this.includeTime && this.timeToDecimal(this.time);
        return `${loc.origin}${loc.pathname.replace("embed/", "")}`.concat(mark ? `?t=${mark}` : '').toLowerCase();
    }

    constructor(
        private interactions: EventInteraction,
        private location: Location,
        @Inject(APP_SETTINGS) private settings: Object
    ) {
        this.videoSizes = settings['VIDEO_EMBED_SIZE_OPTIONS'];
    }

    ngOnInit() {
        this.subscriptions.push(this.interactions.subscribe(e => {
            
            if( e.key == "setMedia"){
                this.media = e.message.media;
            }
            if (e.key == "toggleVideoEmbedShare" ) {
                if (!this.media){
                    return;
                }
                this.active = !this.active
                // pass video object in payload   
                this.duration = this.media.duration/60;          
                this.time = this.toFormattedTime(this.media.currentTime);
            }
        }))
        this.shown = Observable.of(true).delay(250);
        this.setDefaultSize()
    }

    selectSize(size) {
        this.selectedSize = size
    }

    dismiss(_event) {
        this.active = false;
        this.includeTime = false;
        this.setDefaultSize();
    }

    private setDefaultSize() {
        this.selectedSize = this.videoSizes.find(v => v["isDefault"]);
    }

    private timeToDecimal(t) {
        const timeArray = this.time.split(":");
        let hours:number = 0;
        let minutes:number = 0;
        let seconds:number = 0;

        if(timeArray.length > 2)
        {
            hours   = parseInt(timeArray[0]) * 60 * 60;
            minutes = parseInt(timeArray[1]) * 60;
            seconds = parseInt(timeArray[2]);
        }
        else if(timeArray.length > 1)
        {
            minutes = parseInt(timeArray[0]) * 60;
            seconds = parseInt(timeArray[1]);
        }
        else{
            seconds = parseInt(timeArray[0]);
        }
        
        var totalTime = hours + minutes + seconds;
      
        return totalTime;
    }

    private timeToParams(t) {
        //returns time in '00m00s' format
        return t.split(':')
            .map(function (val) { return parseInt(val, 10); })
            .reduce(function (pv, cv, index, array) { return `${!isNaN(pv) ? pv + "m" : ''}${!isNaN(cv) ? cv + "s" : ''}` });
    }

    private toFormattedTime(seconds) {
        let stamp = new Date(seconds * 1000),
            mm = stamp.getMinutes(), ss = stamp.getSeconds();
        return `${mm}:${ss < 10 ? '0' + ss : ss}`;
    }

    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach(s => s.unsubscribe());
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/video-embed/video-embed-share.component.ts